import(/* webpackMode: "eager", webpackExports: ["NavBarWrapper"] */ "/app/src/app/[lang]/(private)/_components/NavBarWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PrivateWrapper"] */ "/app/src/app/[lang]/(private)/_components/PrivateWrapper.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/index.ts");
